import React, {useEffect, useState, useCallback, useMemo} from "react";
import LoginPopUp from "../common/alert/login/LoginPopUp.jsx";
import {useLocation, Link} from "react-router-dom";
import {useNavigate} from "react-router-dom";

const UserAvatar = ({}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [userImage, setUserImage] = useState(null);
    const [isLoginModalOpen, setLoginModalOpen] = useState(false);
    const handleLoginClick = () => {
        const originalUrl = "/account";
        sessionStorage.setItem("originalUrl", originalUrl);
        window.history.pushState({}, "", "/login");
        localStorage.setItem("isPopupManuallyOpened", "true");
        setLoginModalOpen(true);
    };

    const handleModalClose = useCallback(() => {
        setLoginModalOpen(false);
        navigate(location.pathname, {replace: true});
    }, [navigate, location.pathname]);

    const fetchUserImage = useCallback(
        (userId) => {
            return fetch(`https://crowdwisdom.live/wp-json/api/v1/get-user-photo?user_id=${userId}`)
                .then((res) => res.json())
                .then((data) => {
                    if (data && data.photo) {
                        return data.photo;
                    }
                    return "/images/profile_icon.svg"; // fallback on error
                })
                .catch((err) => {
                    console.error("Error fetching user photo:", err);
                    return "/images/profile_icon.svg"; // fallback on error
                });
        },
        []
    );

    const userData = useMemo(() => JSON.parse(localStorage.getItem("cw_portfolio_user")), []);

    useEffect(() => {
        if (!userData || !userData.user_id) {
            setUserImage("/images/profile_icon.svg");
            return;
        }

        fetchUserImage(userData.user_id).then((photo) => setUserImage(photo));
    }, [userData, fetchUserImage]);

    return (
        <>
            {isLoginModalOpen && (
                <LoginPopUp
                    isLoginModalOpen={isLoginModalOpen}
                    setLoginModalOpen={setLoginModalOpen}
                    onClose={handleModalClose}
                />
            )}
            <div
                onClick={() => {
                    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
                    if (!userData) {
                        handleLoginClick(); // redirect to login or show popup
                        return;
                    }
                    window.location.href = "/account";
                }}
                style={{
                    borderRadius: "50%",
                    background: userImage != "/images/profile_icon.svg" ? "none" : "#494d4a",
                    border: "1px solid #494d4a",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                }}
            >
                <img
                    src={userImage || "/images/profile_icon.svg"}
                    alt="Profile"
                    style={{
                        width: userImage != "/images/profile_icon.svg" ? "30px" : "20px",
                        height: userImage != "/images/profile_icon.svg" ? "30px" : "20px",
                        borderRadius: "50%",
                        border: "1px solid #494d4a",
                    }}
                />
            </div>
        </>
    );
};

export default UserAvatar;
